import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Skeleton from '@mui/material/Skeleton'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import React from 'react'

import { TGetFileFunction } from '@/app/module/conversations/types'

type Props = {
  files: string[]
  getFile: TGetFileFunction
  message: string
}

const WhatsappImage: React.FC<Props> = ({ files: initialFiles, getFile, message }) => {
  const [files, setFiles] = React.useState<string[]>([])
  const [loading, setLoading] = React.useState(false)

  return (
    <>
      {!!initialFiles?.length && (
        <>
          {loading && (
            <LoadingCont>
              <CircularProgress />
            </LoadingCont>
          )}
          {!loading &&
            initialFiles.map((image: string, index: number) => {
              if (files[index]) {
                return <img key={index} width="100%" src={files[index]} />
              }
              return (
                <div
                  key={index}
                  style={{
                    position: 'relative',
                  }}
                >
                  <Skeleton variant="rectangular" width="100%" height={200} />
                  <ImageDownloadCont>
                    <Button
                      variant="contained"
                      disableElevation
                      color="primary"
                      onClick={() => {
                        setLoading(true)
                        getFile(image).then((res) => {
                          const updatedFiles: string[] = [...files]
                          updatedFiles[index] = res.url
                          setFiles(updatedFiles)
                          setLoading(false)
                        })
                      }}
                    >
                      Preview Image
                    </Button>
                  </ImageDownloadCont>
                </div>
              )
            })}
        </>
      )}
      <Typography style={{ whiteSpace: 'pre-line' }}>{message}</Typography>
    </>
  )
}

const LoadingCont = styled('div')({
  display: 'flex',
  width: '100%',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '200px',
  minWidth: '300px',
})

const ImageDownloadCont = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  display: 'flex',
  width: '100%',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
})

export default WhatsappImage
